import { render, staticRenderFns } from "./orphan-assets-warnings.vue?vue&type=template&id=411b7675&"
import script from "./orphan-assets-warnings.vue?vue&type=script&lang=js&"
export * from "./orphan-assets-warnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411b7675')) {
      api.createRecord('411b7675', component.options)
    } else {
      api.reload('411b7675', component.options)
    }
    module.hot.accept("./orphan-assets-warnings.vue?vue&type=template&id=411b7675&", function () {
      api.rerender('411b7675', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/orphan-assets-warnings/orphan-assets-warnings.vue"
export default component.exports